// SPDX-License-Identifier: LicenseRef-Pachamama-Proprietary
// Copyright 2026 Pachamama Studios B.V. All rights reserved.

/**
 * AYNI — where the streams are. Production builds name the stream host in
 * `VITE_REALTIME_DASH_BASE_URL` (CI bakes it in); a build without it, a
 * local `npm run dev` for one, reads the same host directly. The Pages
 * proxy that used to stand in for it (`/dash/*`, `/realtime/*`,
 * `/forecast/*`, with a weekly allowance cookie) was retired on
 * 2026-10-21 (security fix plan S-02 step 5, S-06), so every build takes
 * production's path: the live index, the streams and the ten-minute
 * stream token (`streamToken.ts`) against the host itself.
 */

/** The stream host unless the build says otherwise, with its trailing slash. */
export const DEFAULT_STREAM_HOST = 'https://pachamama-studios.stream/'

/** The configured stream host, or the default, always ending in `/`. */
export function streamHostBase(): string {
  const configured = (import.meta.env.VITE_REALTIME_DASH_BASE_URL as string | undefined)?.trim()
  const base = configured || DEFAULT_STREAM_HOST
  return base.endsWith('/') ? base : `${base}/`
}
